import { SET_MONSTER, TOGGLE_LOADING } from './actionType';

const initalState = {
  monster: {},
  isLoading: false,
}

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case SET_MONSTER:
      return {
        ...state,
        monster: action.payload
      }
    case TOGGLE_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    default:
      return state
  }
}

export default reducer